import utils from "./utils"
import _ from "lodash";
import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';
import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.css';
import {disableBodyScroll, enableBodyScroll} from "body-scroll-lock";
import axios from "axios";

let main = function (params) {

    // console.log('LOADING MAIN PAGE');
    //
    // const $page = $('.page-main');
    //
    // const isMobile = utils.isMobileAndTablet();
    //
    // console.log(isMobile);
    //
    // console.log(process.env.SOURCE)

    const $page = $('.page-main');
    const $emailStatus = $page.find('.block.order .statusEmail');
    const $buttonBuy = $page.find('.button.buy');
    const $checkAlien = $('#alien');
    const $checkGift = $('#gift');
    const $giftGroup = $('.gift-wrapper');
    const $input = $('#order-email');
    const $giftEmail = $('#order-gift-email');
    const $giftName = $('#order-gift-name');
    const $giftMessage = $('#order-gift-message');

    $page.find('.legal_year').html(new Date().getFullYear());

    const sliderPlans = new Swiper('.plans-slider', {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 3,
        spaceBetween: 40,
        breakpoints: {
            340: {
                slidesPerView: 1,
                spaceBetween: 10,
                initialSlide: 1
            },
            768: {
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 20,
                initialSlide: 1
            },
            1440: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },

        pagination: {
            el: '.plans-pagination',
        },
    });

    const sliderReviews = new Swiper('.reviews-slider', {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 40,
        breakpoints: {
            340: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 'auto',
                spaceBetween: 20,
            },
            1440: {
                slidesPerView: 'auto',
                spaceBetween: 40,
            },
        },
        pagination: {
            el: '.reviews-pagination',
        },
        navigation: {
            nextEl: '.button.round.right',
            prevEl: '.button.round.left',
        }
    });


    new Accordion('.table', {
        duration: 400,
        elementClass: 'row',
        triggerClass: 'question',
        panelClass: 'answer',
        activeClass: 'active',
        // onOpen: function(currentElement) {
        //     console.log(currentElement);
        // }
    });


    const closeModal = function (modal) {
        const $modal = $('.block.' + modal);
        $modal.removeClass('active');
        enableBodyScroll($modal[0]);
    };
    const activateCloseListeners = function (modal) {
        const $modalElem = $page.find('.block.' + modal);
        $modalElem.on('click', function (e) {
            if (e.target !== e.currentTarget) return;
            // console.log('clicked outside modal frame');
            closeModal(modal);
        });
        $modalElem.find('.close').on('click', function (e) {
            // console.log('clicked close button');
            closeModal(modal);
        });
    };


    activateCloseListeners('order');

    let activeProduct = 2;
    $page.find('.button.go').on('click', function () {
        const $modal = $page.find('.block.order');
        disableBodyScroll($modal[0]);
        $modal.addClass('active');

        activeProduct = $(this).attr('id').split('-')[1];
    });

    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const validate = () => {
        if($checkGift.is(':checked')) {
            if (validateEmail($input.val()) && validateEmail($giftEmail.val()) && $giftName.val() !== '') {
                $input.removeClass('invalidated');
                $buttonBuy.removeClass('disabled');
            } else {
                $input.addClass('invalidated');
                $buttonBuy.addClass('disabled');
            }
        }else{
            if (validateEmail($input.val())) {
                $input.removeClass('invalidated');
                $buttonBuy.removeClass('disabled');
            } else {
                $input.addClass('invalidated');
                $buttonBuy.addClass('disabled');
            }
        }
        return false;
    }

    $input.on('input', validate);
    $giftEmail.on('input', validate);
    $giftName.on('input', validate);
    $checkGift.on('change', function () {
        if ($(this).is(':checked')) {
            $giftGroup.addClass('active');
        } else {
            $giftGroup.removeClass('active');
        }
        validate();
    });


    $buttonBuy.on('click', function(){
        if(!$(this).hasClass('disabled')){
            purchase($input.val(), $giftEmail.val(), $giftName.val(), $giftMessage.val());
        }
    });


    let isButtonActive = true;
    let emailSuggestionShown = false;
    const purchase = function (email, giftEmail, giftName, giftMessage) {
        if (isButtonActive) {
            isButtonActive = false;

            $emailStatus.removeClass('active').html('');
            $buttonBuy.addClass('disabled');

            const referer = window.location.search.substring(1);

            const data = {
                product: activeProduct,
                user: {
                    email: email,
                    phone: '-',
                    emailSuggestionShown: emailSuggestionShown
                },
                referral: referer,
                isAlien: $checkAlien.is(':checked'),
                isGift: $checkGift.is(':checked'),
                recipient: {
                    email: giftEmail,
                    name: giftName,
                    message: giftMessage
                }
            };

            // console.log(data);

            axios.post(process.env.API_URL + 'api/payment/create', data)
                .then(function (response) {
                    response = response.data;
                    if(response.status){
                        window.location.href = response.data.paymentURL;
                    }else{
                        // console.log(response.message);
                        let errorMessage = response.message;
                        if(errorMessage === 'typo'){
                            errorMessage = 'Возможно, вы имели в виду <span class="highlight small">'+response.data.suggestion+'</span>';
                            emailSuggestionShown = true;
                        }
                        $emailStatus.html(errorMessage).addClass('active');
                        $emailStatus.find('.highlight').on('click', function(){
                            $input.val($(this).text());
                            $emailStatus.removeClass('active').html('');
                        });
                        isButtonActive = true;
                        $buttonBuy.removeClass('disabled');
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    isButtonActive = true;
                    $buttonBuy.removeClass('disabled');
                });

        }
    }

};

export default main;